var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'base-follow-button', 
    { active: _vm.isFollowed }
  ],on:{"click":_vm.onClick}},[_c('svg',{attrs:{"id":"heart-icon","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }